function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAgriculture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M36.364,2.572C36.364,10.399 30.535,16.869 22.984,17.868C22.494,14.188 20.875,10.867 18.484,8.27C21.123,3.557 26.167,0.367 31.955,0.367L34.159,0.367C35.379,0.367 36.364,1.352 36.364,2.572ZM1.087,6.981C1.087,5.762 2.072,4.777 3.292,4.777L5.497,4.777C14.02,4.777 20.93,11.687 20.93,20.21L20.93,29.03C20.93,30.249 19.945,31.234 18.726,31.234C17.506,31.234 16.521,30.249 16.521,29.03L16.521,22.415C7.998,22.415 1.087,15.504 1.087,6.981Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAgriculture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/agriculture.1584a8a86f43d59822efded3d8281902.svg";